module.exports = __webpack_public_path__ + "media/images/file-icons/512/001-interface-1-96a3bb7cdf8d0408c02e0a7fa1c69b16.png";